var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._b({staticClass:"obi-dropdown-divider dropdown-divider"},'li',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }